import { ReactNode } from "react";

import classNames from "classnames";

import Footer from "../../layout/Footer/Footer";
import Header from "../../layout/Header/Header";
import { TNavbarOrkaProps } from "../../paginas/navegacion/Navbar";
import { Loading } from "../Loading/Loading";

import "./container.scss";

export type TContainerProps = {
	children?: ReactNode | undefined;
	className?: string;
	navbarOrkaProps?: TNavbarOrkaProps;
	headerWithTransparentBackground?: boolean;
	loading?: boolean;
	noFooter?: boolean;
};

export function Container(props: TContainerProps) {
	return (
		<>
			<div
				className="common-container"
				onScroll={() => {
					const emptyDiv = document.getElementById("empty-div");
					if (!emptyDiv) {
						return;
					}

					const currentTop = emptyDiv.getBoundingClientRect().top;
					const originalTop = emptyDiv.offsetTop;

					const navbar = document.getElementById("my-orka-nav-bar");
					if (!navbar) {
						return;
					}

					if (currentTop < originalTop) {
						navbar.style.boxShadow =
							"0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)";
					} else {
						navbar.style.boxShadow = "none";
					}
				}}>
				<Header
					headerWithTransparentBackground={
						props.headerWithTransparentBackground
					}
				/>
				<div className="common-content-container">
					<main className={classNames(props.className)}>
						<div id="empty-div" />
						{props.children}
					</main>
					<Footer />
				</div>
			</div>
			{props.loading && <Loading absolute />}
		</>
	);
}
